<template>
  <div class="showing-booked-attendees__extra">
    <div class="p15 extra-content">
      <div class="flex justify-center mt-10">
        <div style="width: 70%;" class="flex justify-between">
          <a :href="tel()"><img src="../../assets/icons/phone.svg" alt="icon"></a>
          <img src="../../assets/icons/sms.svg" alt="icon" @click="sms">
          <img src="../../assets/icons/mail.svg" alt="icon" @click="mail">
          <img src="../../assets/icons/pen.svg" alt="icon" @click="editCustomer">
        </div>
      </div>

      <div class="flex justify-between mt-30">
        <div>Lånelöfte</div>
        <div>
          <label class="switch mr-10 opaque-60">
            <input type="checkbox" class="mr-5" @change="updateLoanCommitment" v-model="loanCommitment">
            <div class="slider round"></div>
          </label>
        </div>
      </div>

      <div class="grid2col mt-15  align-middle">
        <div>Äger sitt boende</div>
        <div class="mr-5 comment-wrap">
          <select class="discreet text-right transparent" v-model="customerCommonSearch" @change="updateCustomerCommonSearch">
            <option :value="item.id" v-for="(item, index) in searchingLeavingGroup" v-bind:key="index">{{ item.text }}</option>
          </select>
        </div>
      </div>

      <div class="grid2col mt-30">
        <div v-bind:class="{ 'fg-primary': currentView === 'customerNotes' }" @click.stop="currentView = 'customerNotes'" class="select-none">Kundanteckningar</div>
        <div v-bind:class="{ 'fg-primary': currentView === 'objectNotes' }" class="text-right select-none" @click.stop="currentView = 'objectNotes'">Objektanteckningar</div>
      </div>
      <div v-show="currentView === 'customerNotes'" class="mt-15">
        <div v-show="customerNotes.length">
          <div v-for="(note, index) in customerNotes" :key="index" class="mb-15">
            <p class="fg-grey fs-14">{{ note.createdAt }}</p>
            <p>{{ note.content }}</p>
          </div>
        </div>
        <p v-show="!customerNotes.length" class="fg-grey">Inga kundanteckningar.</p>
      </div>

      <div v-show="currentView === 'objectNotes'" class="mt-15">
        <div v-show="objectNotes.length">
          <div v-for="(note, index) in objectNotes" :key="index" class="mb-15">
            <p class="fg-grey fs-14">{{ note.createdAt }}</p>
            <p>{{ note.content }}</p>
          </div>
        </div>
        <p v-show="!objectNotes.length" class="fg-grey">Inga objektanteckningar.</p>
      </div>
      <textarea class="mt-25 width-100 p15"
                rows="8"
                :placeholder="currentView === 'customerNotes' ? 'Ny kundanteckning':'Ny objektanteckning'"
                v-model="newNote"
                @click.stop>
        </textarea>
      <button class="width-100 outline" @click.stop="saveNote()" :disabled="!newNote.length">
        spara
      </button>
      <spinner v-show="loading"></spinner>
    </div>
  </div>
</template>
<script>
import sendSmsOrMail from '../forms/generic/sendSmsOrMail';
import customerForm from '../forms/visningar/customerForm';
import Spinner from '../spinner';
import Bugsnag from '@bugsnag/js';

export default {
  name: 'CustomerAccordion',
  components: {Spinner},
  props: {
    customer: {
      type: Object,
    },
    customers: {
      type: Array,
    }
  },
  data() {
    return {
      currentView: 'customerNotes',
      customerNotes: [],
      objectNotes: [],
      newNote: '',
      loanCommitment: false,
      loading: false,
      customerCommonSearch: false,
      searchingLeavingGroup: [
        { id: -1, text: 'Ej känt'},
        { id: 0, text: 'Lämnar inget'},
        { id: 1, text: 'Lämnar, ej kontaktad'},
        { id: 10, text: 'Önskar värdering'},
        { id: 6, text: 'Lämnar, vi ska återkomma'},
        { id: 7, text: 'Lämnar, fått information'},
        { id: 8, text: 'Lämnar, intagsförsök pågår'},
        { id: 3, text: 'Säljer genom oss'},
        { id: 4, text: 'Säljer genom annan mäklare'},
      ],
    }
  },
  methods: {
    sms() {
      this.$store.commit('STORE_SMS_MAIL_WHICH_SERVICE', 'showing');

      let receiverData = {
        deliveryWay: "sms",
        receivers : []
      };
      receiverData.receivers.push(this.customer);

      this.$store.commit('STORE_SMS_MAIL_DELIVERYWAY', 'sms');
      this.$store.commit('STORE_SMS_MAIL_RECIEVERS', receiverData.receivers);
      this.$store.commit('STORE_ACTIVE_COMPONENT', sendSmsOrMail);
      this.$root.modalOpen = true;
    },
    mail() {
      this.$store.commit('STORE_SMS_MAIL_WHICH_SERVICE', 'showing');

      let receiverData = {
        deliveryWay: "email",
        receivers : [],
        subject: '',
        message: ''
      };
      receiverData.receivers.push(this.customer);

      this.$store.commit('STORE_SEND_SMS_OR_MAIL_CONTACT_DATA', receiverData);
      this.$store.commit('STORE_ACTIVE_COMPONENT', sendSmsOrMail);
      this.$root.modalOpen = true;
    },
    tel() {
      return "tel:" + (this.customer.cellphone ? this.customer.cellphone : this.customer.phone)
    },
    editCustomer() {
      this.$store.commit('showing/STORE_CURRENT_CUSTOMER', this.customer);
      this.$store.commit('STORE_ACTIVE_COMPONENT', customerForm);
      this.$root.modalOpen = true;
    },
    getObjectNotes(force) {
      // Get object notes
      if (this.objectNotes.length && !force) {
        return false;
      }

      let objectId = this.$route.params.id;
      const endpoint = "/internalapi/note/get-from-object/objectId/" + objectId + "/customerId/" + this.customer.id;

      this.$root.callFasAdApi(endpoint)
      .then((data) => {
        this.objectNotes = data.data;
      })
      .catch((error) => {
        Bugsnag.notify(error)
      });

    },
    getCustomerNotes(force) {
      // Get customer notes
      if (this.customerNotes.length && !force) {
        return false;
      }

      this.$root.callFasAdApi("/internalapi/note/get-from-customer/customerId/" + this.customer.id)
      .then((data) => {
        this.customerNotes = data.data;
      })
      .catch((error) => {
        Bugsnag.notify(error);
      });

    },
    saveNote(){
      if (this.currentView === "customerNotes") {
        // save customer note
        let data = {
          customerId: this.customer.id,
          content: this.newNote
        };
          this.$root.callFasAdApi("/internalapi/note/create-customer-note", "POST", data)
          .then(() => {
            this.getCustomerNotes(true);
            this.newNote = "";
          })
          .catch(console.error);
      } else {
        // save object note
        let data = {
          "objectId": this.$route.params.id,
          "customerIds": [],
          "content": this.newNote
        };
        this.customers.forEach((customer) => {
          data.customerIds.push(customer.id);
        });

        this.$root.callFasAdApi("/internalapi/note/create-object-note", "POST", data)
        .then(() => {
          this.getObjectNotes(true);
          this.newNote = "";
        })
        .catch((error) => {
          Bugsnag.notify(error);
          Bugsnag.notify(data);
        });
      }
    },
    updateLoanCommitment() {
      this.loading = true;
      let data = {
        "customerId": this.customer.id,
        "objectId": this.$route.params.id,
        "loanCommitment": this.loanCommitment
      };
      this.$root.callFasAdApi("/internalapi/customer/update-Loan-commitment", "POST", data)
      .then((data) => {
        this.$root.handleResponseMessage(data);
        this.$store.dispatch('showing/storeShowingDataForSelectedListing', {listingId: this.$route.params.id});
        this.loading = false;
      })
      .catch((error) => {
        Bugsnag.notify(error);
        Bugsnag.notify(data);
      });
    },
    updateCustomerCommonSearch() {
      this.loading = true;
      let data = {
        "id": this.customer.id,
        "isLeaving": this.customerCommonSearch,
      };

      this.$root.callFasAdApi("/internalapi/customer/save-common-search", "POST", data)
      .then((data) => {
        this.$root.handleResponseMessage(data);
        this.$store.dispatch('showing/storeShowingDataForSelectedListing', {listingId: this.$route.params.id});
        this.loading = false;
      })
      .catch((error) => {
        Bugsnag.notify(error);
        Bugsnag.notify(data);
      });
    }
  },
  created() {
    this.customerCommonSearch = this.customer.isleaving
  }
};
</script>
<style>

.showing-booked-attendees__extra .extra-content {
  background-color: #dfdfdf6b;
  box-shadow: inset 0px 11px 8px -10px #CCC, inset 0px -11px 8px -10px #CCC;
}
</style>
